import { Component, OnInit } from '@angular/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { ProposalPdfComponent } from '../../proposal-pdf/proposal-pdf.component'

@Component({
    selector: 'offer-confirmation-modal',
    templateUrl: './offer-confirmation-modal.component.html',
    styleUrls: ['./offer-confirmation-modal.component.scss'],
})
export class OfferConfirmationModalComponent implements OnInit {
    constructor(private readonly modalService: NgbModal) {}

    ngOnInit(): void {}

    openProposal(): void {
        this.modalService.open(ProposalPdfComponent, {
            size: 'xl',
        })
    }

    closeModal(): void {
        this.modalService.dismissAll()
    }
}
